export enum WIDGET_PDF_PREVIEW {
    /**
     * @value No PDF selected
     */
    NO_PDF_SELECTED = 'WIDGET_PDF_PREVIEW.NO_PDF_SELECTED',
    /**
     * @value No PDF preview yet
     * @description Label displayed on the empty box, in the designer, when displaying an empty widget PDF preview. Inform the user that the widget settings are not filled yet.
     */
    PDF_PREVIEW_EMPTY_STATE_TITLE = 'DESIGNER.PDF_PREVIEW_EMPTY_STATE_TITLE',
    /**
     * @value Selected PDF
     */
    SELECTED_PDF = 'WIDGET_PDF_PREVIEW.SELECTED_PDF',
    /**
     * @value Select PDF
     */
    SELECT_PDF = 'WIDGET_PDF_PREVIEW.SELECT_PDF',
    /**
     * @value When configured, the widget displays a PDF preview from the media library.
     * @description Displayed when PDF Preview widget is not configured
     */
    WIDGET_NOT_CONFIGURED_DESCRIPTION = 'WIDGET_PDF_PREVIEW.NOT_CONFIGURED_DESCRIPTION',
}
